import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { FAQS } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="border-y border-ink-700/60 bg-ink-900 py-10 sm:py-12" style={{
    paddingTop: "0px",
    paddingBottom: "5px"
  }} data-id="element-68" data-mp="1bmlo9c6xq5ml">
      <div className="mx-auto max-w-content px-5" data-id="element-69" data-mp="248o6wgjkab1c">
        <SectionHeading eyebrow="❓ ANSWERS" title="Frequently asked" highlight="questions" data-id="element-70" data-mp="249zllbejp378" />

        <ul className="mx-auto mt-6 max-w-3xl space-y-2" data-id="element-71" data-mp="28a9ogf71jdhv">
          {FAQS.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-ink-700 bg-ink-850" data-id="element-72" data-mp="1zi7vt337r1i5" data-mpi={index}>
                <h3 data-id="element-73" data-mp="2n7ipk0m5bvms">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-3.5 text-left" data-id="element-74" data-mp="2n7a8dwizq45s">
                    <span className="text-sm font-bold text-white sm:text-base" data-id="element-75" data-mp="14t7nrjb1xe0a">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-lime-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-76" data-mp="1eldbuhy6nba7" />
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-4 text-sm leading-relaxed text-white/65" data-id="element-77" data-mp="1ohq4rdlwll3w">
                    {faq.answer}
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}